import React from 'react';
import { css } from '@emotion/css';
import appLabels from '../../utils/appLabels';
import formatString from '../../utils/formatString';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useApp } from '../../context/app-context';
import { bannerUrlQueryMapping, isMobile } from '../../utils/utils';

const tileStyle = css`
  width: 18.3125rem;
  padding: 0.75rem;
  box-sizing: border-box;
  max-width: 18.3125rem;

  @media (max-width: 641px) {
    max-width: initial;
  }
`;

const OrderNumberStyle = css`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
`;

const OrderStatusStyle = css`
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 1rem;
`;

const manageLinkStyle = css`
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.125rem;
  text-decoration-line: underline !important;
  color: #7b1a27 !important;
  background: none;
  border: none;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
`;

const CreatedOrderContent = (props) => {
  const upcomingOrders = get(props, 'upcomingOrders');

  const orderStatusMessage = get(props, 'orderStatusMessage');
  const { appData } = useApp();
  const deepLinkUrl = `${getDeepLinkUrl(appData.banner)}c=em_allb_alld_ecom_ordrcpref_0&af_sub1=em_allb_alld_ecom_ordrcpref_0&af_sub3=AROrderConfirmationTheme&af_dp=${appData.banner}App://pushsection=editOrderCart&storeId=${get(upcomingOrders, 'storeId', '')}&orderId=${get(upcomingOrders, 'upcomingOrder.orderID')}&af_web_dp=https://www.${appData.banner}.com/order-account/orders?cmpid=em_allb_alld_ecom_ordrcpref_0&deliveryName=0&af_ios_url=https://www.${appData.banner}.com/order-account/orders?cmpid=em_allb_alld_ecom_ordrcpref_0&deliveryName=0&af_android_url=https://www.${appData.banner}.com/order-account/orders?cmpid=em_allb_alld_ecom_ordrcpref_0&deliveryName=0&af_esp=true`;
  const orderDetailLink = isMobile()
    ? deepLinkUrl
    : formatString(appLabels.CreateOrderContent.manageLinkUrl, {
        orderId: get(upcomingOrders, 'upcomingOrder.orderID'),
      });

  // Function to construct the deepLinkUrl based on a banner
  function getDeepLinkUrl(banner) {
    const identifier = get(bannerUrlQueryMapping, banner, null);
    if (!identifier) {
      console.error(`No link found for keyword: ${banner}`);
      return null;
    }
    return `https://${banner}.onelink.me/${identifier}?pid=Email&`;
  }

  const analyticsEvents = (name) => {
    try {
      if (window['AB']?.DATALAYER) {
        window['AB']?.DATALAYER.analyticsCTATracking(name);
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };
  const ariaOrderNumber = `${get(upcomingOrders, 'upcomingOrder.orderID')}`.split('').join(' ');

  return (
    <div className={tileStyle} data-testid="created-order-content">
      <div className={OrderNumberStyle} aria-label={`Order number ${ariaOrderNumber}`}>
        {formatString(appLabels.CreateOrderContent.orderNumber, {
          number: get(upcomingOrders, 'upcomingOrder.orderID'),
        })}
      </div>

      <div className={OrderStatusStyle}>{orderStatusMessage}</div>

      <a
        className={manageLinkStyle}
        href={orderDetailLink}
        onClick={() => analyticsEvents('cta:upcoming-orders-enrolled|link|view-manage-order')}
        data-testid="manage-order-link"
      >
        <button className={`${manageLinkStyle}`} aria-label={appLabels.CreateOrderContent.manageLinkText}>
          {appLabels.CreateOrderContent.manageLinkText}
        </button>
      </a>
    </div>
  );
};

CreatedOrderContent.propTypes = {
  upcomingOrders: PropTypes.object,
  orderStatusMessage: PropTypes.string,
  onExpand: PropTypes.func,
};

export default CreatedOrderContent;
